import { createRouter, createWebHistory } from 'vue-router'
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import Confirm from "../views/auth/Confirm.vue";
import PageNotFound from "../views/PageNotFound.vue";
import Settings from "../views/auth/Settings.vue";
import VerifyDob from "../views/auth/VerifyDob.vue";
import FrontLayout from '@/layouts/FrontLayout.vue';
import MWPLogin from "@/components/mwp/MWPLogin.vue";
import MWILogin from "@/components/mwi/MWILogin.vue";
import MWIRegister from "@/components/mwi/MWIRegister.vue"
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import { APP } from "@/config/app";
import MWPLayout from "@/layouts/MWPLayout.vue";
import MWILayout from "@/layouts/MWILayout.vue";
import PrivacyNoticeMW from "../views/PrivacyNoticeMW.vue";

import { fetchAuthSession } from "aws-amplify/auth";
import { useCognitoStore } from '@/stores/cognito';

import { captureTrafficSource } from '@/utils/utmTracking.js';
import { hasSippNoSecurityAllocationsAndTargetRetirementAge } from "@/guards/hasSippNoSecurityAllocationsAndTargetRetirementAge";
import { canMakePayments } from "@/guards/canMakePayments";
import { hasBeneficiariesAllowed } from "@/guards/hasBeneficiariesAllowed";
import {hasNoTargetRetirementAge} from "@/guards/hasNoTargetRetirementAge";

import Login from "../views/auth/Login.vue";
import {handleSignOut} from "@/utils/cognito";

import { redirectWithQuery } from "@/utils/routeQuery";

//CMS routes - mywealth only - FrontLayout
const mywealth_only_routes = [
  {
    path: "/",
    name: 'Home',
    component: Login,
    meta: {
      title: 'Login',
      layout: FrontLayout
    }
  },
  {
    path: "/our-new-look",
    name: 'Our new look',
    component:() => import('../views/OurNewLook.vue'),
    meta: {
      title: 'Our new look',
      layout: FrontLayout
    }
  },
  {
    path: "/global-index-service",
    name: 'GlobalIndexService',
    component: () => import('../views/GlobalIndexService.vue'),
    meta: {
      title: 'Global Index Service',
      layout: FrontLayout
    }
  },
  {
    path: "/self-select-service",
    name: 'SelfSelectService',
    component: () => import('../views/SelfSelectService.vue'),
    meta: {
      title: 'Self-Select Service',
      layout: FrontLayout
    }
  },
  {
    path: "/privacy-notice",
    name: 'PrivacyNotice',
    component: PrivacyNoticeMW,
    meta: {
      title: 'Privacy Notice',
      layout: FrontLayout
    }
  },
  {
    path: "/get-in-touch",
    name: 'GetInTouch',
    component: () => import('../views/GetInTouchView.vue'),
    meta: {
      title: "Get in Touch",
      layout: FrontLayout
    },
  },
  {
    path: "/news",
    name: 'News',
    component: () => import('../views/News.vue'),
    meta: {
      title: 'News',
      layout: FrontLayout
    }
  },
  {
    path: "/news/:newsId",
    name: 'News Post',
    component: () => import('../views/NewsPost.vue'),
    props: route => ({
      newsId: route.params.newsId,
    }),
    meta: {
      title: 'News Post',
      layout: FrontLayout
    }
  },
];

const mywealthinvest_redirects = [
  {
    path: "/",
    name: 'home-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/"
      )
    },
  },
  {
    path: "/our-new-look",
    name: 'Our new look',
    component:() => import('../views/OurNewLook.vue'),
    meta: {
      title: 'Our new look',
      layout: FrontLayout
    }
  },
  {
    path: "/global-index-service",
    name: 'gi-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/global-index-service"
      )
    },
  },
  {
    path: "/self-select-service",
    name: 'ss-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/self-select-service"
      )
    },
  },
  {
    path: "/privacy-notice",
    name: 'privacy',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/privacynotice"
      )
    },
  },
  {
    path: "/terms-conditions",
    name: 'terms',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/termsconditions"
      )
    },
  },
  {
    path: "/get-in-touch",
    name: 'git',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/get-in-touch"
      )
    },
  },
  {
    path: "/news",
    name: 'News',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/news"
      )
    },
  },
  {
    path: "/personal-pension/faqs",
    name: 'mi-faqs-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthWebsite,"/personal-pension/faqs"
      )
    },
  },
];

const mywealthprivate_redirects = [
  {
    path: "/",
    name: 'home-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/"
      )
    },
  },
  {
    path: "/investment-advice",
    name: 'ia-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/investment-advice"
      )
    },
  },
  {
    path: "/retirement-planning",
    name: 'rp-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/retirement-planning"
      )
    },
  },
  {
    path: "/retirement-planning/defined-benefit-pensions",
    name: 'rp-dbp-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/retirement-planning/defined-benefit-pensions"
      )
    },
  },
  {
    path: "/about-us",
    name: 'au-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/about-us"
      )
    },
  },
  {
    path: "/about-us/our-isa-and-sipp",
    name: 'au-o-isa-a-sipp-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/about-us/our-isa-and-sipp"
      )
    },
  },
  {
    path: "/about-us/our-advisers",
    name: 'au-oa-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/about-us/our-advisers"
      )
    },
  },
  {
    path: "/about-us/testimonials",
    name: 'au-t-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/about-us/testimonials"
      )
    },
  },
  {
    path: "/news",
    name: 'news-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/news"
      )
    },
  },
  {
    path: "/get-in-touch",
    name: 'git-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/get-in-touch"
      )
    },
  },
  {
    path: "/privacy-notice",
    name: 'mi-pp-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/privacy-policy"
      )
    },
  },
  {
    path: "/useful-links/cookies-policy",
    name: 'mi-cp-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/cookies-policy"
      )
    },
  },
  {
    path: "/useful-links/disclaimer",
    name: 'mi-d-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/disclaimer"
      )
    },
  },
  {
    path: "/useful-links/faqs",
    name: 'mi-faqs-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/faqs"
      )
    },
  },
  {
    path: "/useful-links/glossary",
    name: 'mi-g-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/glossary"
      )
    },
  },
  {
    path: "/useful-links/accessibility",
    name: 'mi-a-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/accessibility"
      )
    },
  },
  {
    path: "/useful-links/how-to-make-a-complaint",
    name: 'mi-htmac-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/how-to-make-a-complaint"
      )
    },
  },
  {
    path: "/useful-links/app-download",
    name: 'mi-ad-redirect',
    beforeEnter(to) {
      redirectWithQuery(to, APP.MyWealthPrivateWebsite,"/useful-links/app-download"
      )
    },
  },
];

const routes = [

  // Auth routes
  // Manual registration should only be available in MyWealthInvest mode
  ...(APP.MyWealthMode ? [] : [{
    path: "/register",
    name: "Register",
    component: MWIRegister,
    meta: {
      title: 'Register',
      layout: MWILayout
    }
  }]),
  {
    path: "/login",
    name: "Login",
    component: APP.MyWealthMode ? MWPLogin : MWILogin,
    meta: {
      title: 'Log in',
      layout: APP.MyWealthMode ? MWPLayout : MWILayout,
    },
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: 'Forgot Password',
      layout: APP.MyWealthMode ? MWPLayout : MWILayout,
    }
  },
  {
    path: "/confirm",
    name: "Confirm",
    component: Confirm,
    meta: {
      title: 'Confirm your account',
      layout: APP.MyWealthMode ? MWPLayout : MWILayout,
    }
  },
  {
    path: "/verify-dob",
    name: "VerifyDob",
    component: VerifyDob,
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Verify your date of birth',
      layout: APP.MyWealthMode ? MWPLayout : MWILayout,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Settings',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (Dashboard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/DashboardView.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Dashboard',
      layout: DashboardLayout
    },
  },
  {
    path: '/account/product',
    name: 'Product',
    component: () => import('../views/onboarding/Product.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Product',
      layout: FrontLayout
    },
  },
  {
    path: "/account/illustrations-self-select-pensions",
    name: 'IllustrationsSelfSelectPensions',
    component: () => import('../views/IllustrationsSelfSelectPensions.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Illustrations Self-Select Pensions',
      layout: FrontLayout
    },
  },
  {
    path: '/account/fund-selection/:portfolioId',
    name: 'FundSelection',
    component: () => import('../views/onboarding/FundSelection.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fund Selection',
      layout: FrontLayout
    },
  },
  {
    path: '/account/fund-catalogue/:portfolioId',
    name: 'FundCatalogue',
    component: () => import('../views/onboarding/FundCatalogue.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fund Catalogue',
      layout: FrontLayout
    },
  },
  {
    path: '/account/fund-allocation/:portfolioId',
    name: 'FundAllocation',
    component: () => import('../views/onboarding/FundAllocation.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fund Allocation',
      layout: FrontLayout
    },
  },
  {
    path: '/account/fees/:portfolioId',
    name: 'Fees',
    component: () => import('../views/onboarding/Fees.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fees',
      layout: FrontLayout
    },
  },
  {
    path: '/account/isa-declaration/:portfolioId?',
    name: 'IsaDeclaration',
    component: () => import('../views/onboarding/IsaDeclaration.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'ISA Declaration',
      layout: FrontLayout
    },
  },
  {
    path: '/account/important-information/:portfolioId?',
    name: 'ImportantInformation',
    component: () => import('../views/onboarding/ImportantInformation.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Important Information',
      layout: FrontLayout
    },
  },
  {
    path: '/account/address',
    name: 'Address',
    component: () => import('../views/onboarding/Address.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Address',
      layout: FrontLayout
    },
  },
  {
    path: '/account/personal-information',
    name: 'PersonalInformation',
    component: () => import('../views/onboarding/PersonalInformation.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Personal Information',
      layout: FrontLayout
    },
  },
  {
    path: '/account/phone-number',
    name: 'PhoneNumber',
    component: () => import('../views/onboarding/PhoneNumber.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Phone Number',
      layout: FrontLayout
    },
  },
  {
    path: '/account/bank-account',
    name: 'BankAccount',
    component: () => import('../views/onboarding/BankAccount.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Bank Account',
      layout: FrontLayout
    },
  },
  {
    path: '/account/processing',
    name: 'Processing',
    component: () => import('../views/onboarding/Processing.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Processing',
      layout: FrontLayout
    },
  },
  {
    path: '/dashboard/mobile-app-prompt',
    name: 'MobileAppPrompt',
    component: () => import('../views/dashboard/MobileAppPrompt.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Check out our mobile app',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/choose-how-to-invest/:portfolioId',
    name: 'ChooseHowToInvest',
    component: () => import('../views/dashboard/ChooseHowToInvest.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Choose how to invest your ISA/GIA',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/payment-options/:portfolioId',
    name: 'PaymentOptions',
    component: () => import('../views/dashboard/PaymentOptions.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Payment Instruction',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/payment-status',
    name: 'PaymentStatus',
    component: () => import('../views/dashboard/PaymentStatus.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Payment Status',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/bank-transfer/:portfolioId',
    name: 'BankTransfer',
    component: () => import('../views/dashboard/BankTransfer.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Bank Transfer',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/bank-transfer/pension-disclaimer/:portfolioId',
    name: 'PensionBankTransferDisclaimer',
    component: () => import('../views/dashboard/PensionBankTransferDisclaimer.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Pension Bank Transfer Disclaimer',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/saye-transfer/:portfolioId',
    name: 'SayeTransfer',
    component: () => import('../views/dashboard/SayeTransfer.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Transfer SAYE shares',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/fund-to-fund-transfer/:portfolioId/:fundId',
    name: 'FundToFundTransfer',
    component: () => import('../views/dashboard/FundToFundTransfer.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Fund to Fund transfer',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/withdrawal/:portfolioId',
    name: 'Withdrawal',
    component: () => import('../views/dashboard/Withdrawal.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Withdrawal',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/investment-selection/:portfolioId',
    name: 'BuyingAllocation',
    component: () => import('../views/dashboard/BuyingAllocation.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Investment Selection',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/update-fund-selection/:portfolioId',
    name: 'UpdateFundSelection',
    component: () => import('../views/dashboard/UpdateFundSelection.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Update Fund Selection',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/transactions/:portfolioId',
    name: 'Transactions',
    component: () => import('../views/dashboard/Transactions.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Transactions',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/messages',
    name: 'Messages',
    component: () => import('../views/dashboard/Messages.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Messages',
      layout: DashboardLayout
    },
    children: [
      {
        path: ':messageId',
        name: 'MessageContent',
        component: () => import('../views/dashboard/Messages/MessageContent.vue'),
      }
    ]
  },
  {
    path: '/dashboard/documents',
    name: 'Documents',
    component: () => import('../views/dashboard/Documents.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Documents',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/support',
    name: 'Support',
    component: () => import('../views/dashboard/Support.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Support',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/market-news',
    name: 'Market News',
    component: () => import('../views/dashboard/MarketNews.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Market News',
      layout: DashboardLayout
    },
  },
  {
    path: "/dashboard/market-news/:postId",
    name: 'Market News Post',
    component: () => import('../views/dashboard/MarketNews/MarketNewsPost.vue'),
    beforeEnter: isAuthenticated,
    props: route => ({
      postId: route.params.postId,
    }),
    meta: {
      requiresAuth: true,
      title: 'Market News Post',
      layout: DashboardLayout
    }
  },
  {
    path: '/dashboard/fees/:portfolioId',
    name: 'DashboardFees',
    component: () => import('../views/dashboard/Fees.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fees',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/all-funds/:portfolioId',
    name: 'AllFunds',
    component: () => import('../views/dashboard/AllFunds.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'All Funds',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/payroll-contribution/:portfolioId',
    name: 'PayrollContribution',
    component: () => import('../views/dashboard/PayrollContribution.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Payroll Contribution',
      layout: DashboardLayout
    },
  },

  {
    path: '/dashboard/fund-selection/:portfolioId',
    name: 'DashboardFundSelection',
    component: () => import('../views/dashboard/FundSelection.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fund Selection',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/fund-catalogue/:portfolioId',
    name: 'DashboardFundCatalogue',
    component: () => import('../views/dashboard/FundCatalogue.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Fund Catalogue',
      layout: DashboardLayout
    },
  },
  {
    path: '/dashboard/diversify/:portfolioId',
    name: 'Diversify',
    component: () => import('../views/dashboard/Diversify.vue'),
    beforeEnter: [isAuthenticated],
    meta: {
      requiresAuth: true,
      title: 'Diversify',
      layout: DashboardLayout
    },
  },
  {
    path: "/:notFound(.*)",
    name:'PageNotFound',
    component: PageNotFound,
    meta: {
      title: 'Page Not Found',
      layout: APP.MyWealthMode ? MWPLayout : MWILayout,
    }
  },
  {
    path: '/dashboard/bank-accounts',
    name: 'Bank Accounts',
    component: () => import('../views/dashboard/BankAccounts.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Bank Accounts',
      layout: DashboardLayout
    }
  },
  {
    path: '/dashboard/my-account',
    name: 'My Account',
    component: () => import('../views/dashboard/MyAccount.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'My Account',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/onboarding/:portfolioId',
    name: 'PensionOnboarding',
    component: () => import('../views/pension/Onboarding.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Pension',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/transfer-or-add/:portfolioId',
    name: 'PensionTransferOrAdd',
    component: () => import('../views/pension/TransferOrAdd.vue'),
    beforeEnter: [isAuthenticated, hasSippNoSecurityAllocationsAndTargetRetirementAge],
    meta: {
      requiresAuth: true,
      title: 'Transfer other pension or add cash to your pension',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/fund-selection/:portfolioId',
    name: 'PensionFundSelection',
    component: () => import('../views/pension/FundSelection.vue'),
    beforeEnter: [isAuthenticated, hasNoTargetRetirementAge],
    meta: {
      requiresAuth: true,
      title: 'Pension Fund Selection',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/transfer/:portfolioId',
    name: 'PensionTransfer',
    component: () => import('../views/pension/Transfer.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Transfer Pension',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/beneficiaries/view/:portfolioId',
    name: 'PensionBeneficiariesView',
    component: () => import('../views/pension/BeneficiariesView.vue'),
    beforeEnter: [isAuthenticated, hasBeneficiariesAllowed],
    meta: {
      requiresAuth: true,
      title: 'Pension Beneficiaries',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/beneficiaries/edit/:portfolioId',
    name: 'PensionBeneficiariesEdit',
    component: () => import('../views/pension/BeneficiariesEdit.vue'),
    beforeEnter: [isAuthenticated, hasBeneficiariesAllowed],
    meta: {
      requiresAuth: true,
      title: 'Pension Beneficiaries',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/disclaimer/:portfolioId',
    name: 'PensionTransferRequestDisclaimer',
    component: () => import('../views/pension/Disclaimer.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Pension Transfer Request Disclaimer',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/choose-pay-in-method/:portfolioId',
    name: 'PensionChoosePayInMethod',
    component: () => import('../views/pension/ChoosePayInMethod.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Choose Pay In Method',
      layout: DashboardLayout
    },
  },
  {
    path: '/pension/we-suggest-a-change/:portfolioId',
    name: 'PensionWeSuggestAChange',
    component: () => import('../views/pension/WeSuggestAChange.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'We Suggest A Change',
      layout: DashboardLayout
    },
  },
  {
    path: '/eligibility/:productName/:portfolioId?',
    name: 'Eligibility',
    component: () => import('../views/Eligibility.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'Eligibility',
      layout: FrontLayout
    },
  },
  {
    path: '/dashboard/appchat',
    name: 'AppChat',
    component: () => import('../views/dashboard/AppChat.vue'),
    beforeEnter: isAuthenticated,
    meta: {
      requiresAuth: true,
      title: 'AppChat',
      layout: DashboardLayout
    },
  },
  {
    path: "/dashboard/appchat/:postId",
    name: 'AppChat Post',
    component: () => import('../views/dashboard/AppChat/AppChatPost.vue'),
    beforeEnter: isAuthenticated,
    props: route => ({
      postId: route.params.postId,
    }),
    meta: {
      requiresAuth: true,
      title: 'AppChat Post',
      layout: DashboardLayout
    }
  },
];

const mergedRoutes = [ ...(APP.MyWealthMode ? mywealthprivate_redirects : mywealthinvest_redirects), ...routes ];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: mergedRoutes,
  linkActiveClass: 'active',
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  }
})

async function isAuthenticated(to, from, next) {
    const storeCognito = useCognitoStore();

    const autoLogoutLength = parseInt(import.meta.env.VITE_TIMEOUT);

    if (storeCognito.timeout !== '' && Date.now() > storeCognito.timeout + autoLogoutLength) {
        await handleSignOut();

        storeCognito.timeout = '';

        await router.push({
            name: "Login",
            query: {
                timedOut: true
            },
        });
    } else {
        storeCognito.timeout = Date.now();
    }

    try {
        const response = await fetchAuthSession();

        if (response.tokens) {
          storeCognito.authenticated = true;
          next();
        } else {
          storeCognito.authenticated = false;
          next("/login");
        }
    } catch (err) {
        console.log(err);
        storeCognito.authenticated = false;
    }
}

const siteName = APP.MyWealthMode ? 'My Wealth Private' : 'My Wealth Invest';

// Handle dynamic import errors (Ex. when a new deployment changes hashes in the chunk filenames)
router.onError((error, to) => {
  const isChunkLoadError = error.message?.includes('Failed to fetch dynamically imported module') ||
                           error.message?.includes('Importing a module script failed') ||
                           error.message?.includes('dynamically imported module');

  if (isChunkLoadError) {
    const hasReloaded = to.query?._reloaded === '1';
    
    if (hasReloaded) {
      console.error('Dynamic import failed after reload. Not reloading again to avoid infinite loop.');

      return;
    }
    
    console.warn('Dynamic import failed, likely due to new deployment. Reloading page...');
    const separator = to.fullPath.includes('?') ? '&' : '?';
    window.location.href = to.fullPath + separator + '_reloaded=1';
  }
});

router.beforeEach((to, from, next) => {
  captureTrafficSource(to);

  const guestOnlyRoutes = [
    '/login',
    '/register',
  ]

  const storeCognito = useCognitoStore();

  if (guestOnlyRoutes.indexOf(to.href) > -1 && storeCognito.isAuthenticated) {
    return next('/dashboard');
  }

  // If the route has a title, set it as the page title of the document/page
  document.title = to?.meta?.title != null ?
    to.meta.title + ' - ' + siteName:
    siteName;

  // Continue resolving the route
  next()
})

export default router
